import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Bac } from '@app/library/models/bac.model';
import {
  ClearBacFailure,
  ClearBacNotPossible,
  ClearBacRequest,
  ClearBacSuccess,
} from '@app/library/states/bacs.actions';
import { Actions, ofActionDispatched, ofActionSuccessful, Store } from '@ngxs/store';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'rk-clear-bac-modal',
  templateUrl: './clear-bac-modal.component.html',
  styleUrls: ['./clear-bac-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ClearBacModalComponent implements OnInit {
  isLoading$ = new BehaviorSubject<boolean>(false);
  hasError$ = new BehaviorSubject<boolean>(false);

  constructor(
    public readonly dialogRef: MatDialogRef<ClearBacModalComponent>,
    private readonly store: Store,
    private readonly action$: Actions,
    @Inject(MAT_DIALOG_DATA) public bac: Bac,
  ) {}

  ngOnInit() {
    this.action$.pipe(ofActionDispatched(ClearBacRequest)).subscribe(() => {
      this.isLoading$.next(true);
      this.hasError$.next(false);
    });

    this.action$
      .pipe(ofActionDispatched(ClearBacSuccess, ClearBacFailure, ClearBacNotPossible))
      .subscribe(() => this.isLoading$.next(false));

    this.action$
      .pipe(ofActionDispatched(ClearBacFailure, ClearBacNotPossible))
      .subscribe(() => this.hasError$.next(true));

    this.action$
      .pipe(ofActionSuccessful(ClearBacSuccess))
      .subscribe(() => this.dialogRef.close(true));
  }

  onSubmit() {
    this.store.dispatch(new ClearBacRequest(this.bac.id));
  }
  onCancel() {
    this.dialogRef.close(false);
  }
  onAbort() {
    this.dialogRef.close(false);
  }
}
